module.exports = __webpack_public_path__ + "static/media/verdeSam.89908d61.jpg";